// eslint-disable-next-line import/no-cycle
import store from '../store/store';

export const ButtonEnabled = (name) => {
  const { config } = store.getState();
  return config.FEATURES?.buttons?.map((button) => button.toUpperCase()).includes(name.toUpperCase());
};

export const WidgetEnabled = (name) => {
  const { config } = store.getState();
  return config.FEATURES?.widgets?.map((widget) => widget.toUpperCase()).includes(name.toUpperCase());
};

export const isToolbarItemDisabled = (item) => (
  typeof item.disabled === 'function' ? item.disabled() : item.disabled
);

export const enabledToolbarItems = (items = []) => items
  .filter((item) => item && !isToolbarItemDisabled(item))
  .map((item) => {
    const filteredItem = { ...item };

    if (Array.isArray(item.options)) {
      filteredItem.options = enabledToolbarItems(item.options);
    } else if (typeof item.options === 'function') {
      filteredItem.options = (...args) => enabledToolbarItems(item.options(...args) || []);
    }

    if (Array.isArray(item.groupedTools)) {
      filteredItem.groupedTools = enabledToolbarItems(item.groupedTools);
    }

    return filteredItem;
  });
